import React from 'react';

const Blogs = () => {
    return (
        <div>
            <h1 className='font-bold text-4xl mt-7 bg-clip-text text-transparent bg-gradient-to-r from-red-500 to-blue-500'>COMMING SOON...</h1>
        </div>
    );
};

export default Blogs;